<template>
    <div class="flex items-center gap-1 text-sm font-bold uppercase text-drip">
        <Icon name="truck" class="text-[20px]" />
        <slot />
    </div>
</template>
